import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'shared/interface';

export const useIsLoggedIn = () => {
	const login = useSelector<State, any>((state) => state.login);

	if (login?.userDetails && Object.keys(login.userDetails).length > 0) {
		return true;
	}

	return false;
};
export const useLoggedFromBackground = () => {
	const state = useSelector<State, any>((state) => state.login.backgroundLogin);
	const [status, setStatus] = useState(state);
	useEffect(() => {
		if (state !== status) {
			setStatus(state);
		}
	}, [state]);

	return status;
};
